"use client";

import { c as _c } from "react/compiler-runtime";
import { DELEGATION_ABI } from "@/abis/abis";
import { useAuth } from "@/components/auth/Auth";
import { PRIMARY_ADDRESS_USE_CASE } from "@/components/delegation/delegation-constants";
import EtherscanIcon from "@/components/user/utils/icons/EtherscanIcon";
import OpenseaIcon from "@/components/user/utils/icons/OpenseaIcon";
import CopyIcon from "@/components/utils/icons/CopyIcon";
import { DELEGATION_ALL_ADDRESS, DELEGATION_CONTRACT, NEVER_DATE } from "@/constants/constants";
import type { ApiWallet } from "@/generated/models/ApiWallet";
import { getTransactionLink } from "@/helpers/Helpers";
import { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import { useCopyToClipboard } from "react-use";
import { useWaitForTransactionReceipt, useWriteContract } from "wagmi";
import UserPageIdentityStatementsConsolidatedAddressesItemPrimary from "./UserPageIdentityStatementsConsolidatedAddressesItemPrimary";
export default function UserPageIdentityStatementsConsolidatedAddressesItem(t0) {
  const $ = _c(95);
  const {
    address,
    primaryAddress,
    canEdit
  } = t0;
  const {
    setToast
  } = useAuth();
  let t1;
  if ($[0] !== address.wallet) {
    t1 = e => {
      e.stopPropagation();
      window.open(`https://opensea.io/${address.wallet}`, "_blank");
    };
    $[0] = address.wallet;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const goToOpensea = t1;
  let t2;
  if ($[2] !== address.wallet) {
    t2 = () => {
      window.open(`https://etherscan.io/address/${address.wallet}`, "_blank");
    };
    $[2] = address.wallet;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const goToEtherscan = t2;
  let t3;
  if ($[4] !== address.wallet) {
    t3 = address.wallet.toLowerCase();
    $[4] = address.wallet;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== primaryAddress) {
    t4 = primaryAddress?.toLowerCase();
    $[6] = primaryAddress;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const isPrimary = t3 === t4;
  let t5;
  if ($[8] !== address.wallet) {
    t5 = address.wallet.slice(0, 6);
    $[8] = address.wallet;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const [title, setTitle] = useState(t5);
  const [, copyToClipboard] = useCopyToClipboard();
  let t6;
  if ($[10] !== address.wallet || $[11] !== copyToClipboard) {
    t6 = () => {
      copyToClipboard(address.wallet);
      setTitle("Copied!");
      setTimeout(() => {
        setTitle(address.wallet.slice(0, 6));
      }, 1000);
    };
    $[10] = address.wallet;
    $[11] = copyToClipboard;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleCopy = t6;
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  let t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setIsTouchScreen(window.matchMedia("(pointer: coarse)").matches);
    };
    t8 = [];
    $[13] = t7;
    $[14] = t8;
  } else {
    t7 = $[13];
    t8 = $[14];
  }
  useEffect(t7, t8);
  const [assigningPrimary, setAssigningPrimary] = useState(false);
  const [statusMessage, setStatusMessage] = useState();
  const writeDelegation = useWriteContract();
  let t9;
  if ($[15] !== writeDelegation.data) {
    t9 = {
      confirmations: 1,
      hash: writeDelegation.data
    };
    $[15] = writeDelegation.data;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const waitWriteDelegation = useWaitForTransactionReceipt(t9);
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = function getError(e_0) {
      return e_0.message.split("Request Arguments")[0];
    };
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const getError = t10;
  let t11;
  if ($[18] !== setToast || $[19] !== waitWriteDelegation.data || $[20] !== waitWriteDelegation.error || $[21] !== waitWriteDelegation.isLoading || $[22] !== writeDelegation.data || $[23] !== writeDelegation.isPending) {
    t11 = () => {
      if (writeDelegation.isPending) {
        setStatusMessage("Confirm in your wallet...");
      } else {
        if (writeDelegation.data) {
          const trxLink = <>{writeDelegation.data && <a href={getTransactionLink(DELEGATION_CONTRACT.chain_id, writeDelegation.data)} target="_blank" rel="noopener noreferrer" className="tw-text-primary-400 tw-underline">View Transaction</a>}</>;
          if (waitWriteDelegation.isLoading) {
            setStatusMessage(<>Waiting for confirmation... {trxLink}</>);
          } else {
            if (waitWriteDelegation.data) {
              setStatusMessage(<>Confirmed! Check back in a few minutes to see the change. {trxLink}</>);
              setToast({
                type: "success",
                message: "Primary address set successfully"
              });
            } else {
              if (waitWriteDelegation.error) {
                setStatusMessage(<>Error: {getError(waitWriteDelegation.error)} {trxLink}</>);
                setToast({
                  type: "error",
                  message: `Error setting primary address: ${getError(waitWriteDelegation.error)}`
                });
              }
            }
          }
        } else {
          setStatusMessage(undefined);
        }
      }
    };
    $[18] = setToast;
    $[19] = waitWriteDelegation.data;
    $[20] = waitWriteDelegation.error;
    $[21] = waitWriteDelegation.isLoading;
    $[22] = writeDelegation.data;
    $[23] = writeDelegation.isPending;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== waitWriteDelegation.status || $[26] !== writeDelegation.status) {
    t12 = [writeDelegation.status, waitWriteDelegation.status];
    $[25] = waitWriteDelegation.status;
    $[26] = writeDelegation.status;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  useEffect(t11, t12);
  let t13;
  if ($[28] !== address.wallet || $[29] !== writeDelegation) {
    t13 = async () => {
      setAssigningPrimary(true);
      writeDelegation.writeContract({
        address: DELEGATION_CONTRACT.contract,
        abi: DELEGATION_ABI,
        chainId: DELEGATION_CONTRACT.chain_id,
        functionName: "registerDelegationAddress",
        args: [DELEGATION_ALL_ADDRESS, address.wallet, NEVER_DATE, PRIMARY_ADDRESS_USE_CASE.use_case, true, 0]
      });
    };
    $[28] = address.wallet;
    $[29] = writeDelegation;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const assignPrimary = t13;
  const t14 = `opensea-tooltip-${address.wallet}`;
  let t15;
  if ($[31] !== isTouchScreen) {
    t15 = isTouchScreen ? null : {
      "data-tooltip-content": "Opensea"
    };
    $[31] = isTouchScreen;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="tw-h-6 tw-w-6 tw-flex-shrink-0 tw-transition tw-duration-300 tw-ease-out hover:tw-scale-110 sm:tw-h-5 sm:tw-w-5"><OpenseaIcon /></div>;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== goToOpensea || $[35] !== t14 || $[36] !== t15) {
    t17 = <button onClick={goToOpensea} aria-label="Go to Opensea" className="tw-border-none tw-bg-transparent tw-p-0" data-tooltip-id={t14} {...t15}>{t16}</button>;
    $[34] = goToOpensea;
    $[35] = t14;
    $[36] = t15;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== address.wallet || $[39] !== isTouchScreen) {
    t18 = !isTouchScreen && <Tooltip id={`opensea-tooltip-${address.wallet}`} place="top" positionStrategy="fixed" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }} />;
    $[38] = address.wallet;
    $[39] = isTouchScreen;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  const t19 = `etherscan-tooltip-${address.wallet}`;
  let t20;
  if ($[41] !== isTouchScreen) {
    t20 = !isTouchScreen ? {
      "data-tooltip-content": "Etherscan"
    } : null;
    $[41] = isTouchScreen;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="tw-h-6 tw-w-6 tw-flex-shrink-0 tw-transition tw-duration-300 tw-ease-out hover:tw-scale-110 sm:tw-h-5 sm:tw-w-5"><EtherscanIcon /></div>;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== goToEtherscan || $[45] !== t19 || $[46] !== t20) {
    t22 = <button onClick={goToEtherscan} aria-label="Go to Etherscan" className="tw-border-none tw-bg-transparent tw-p-0" data-tooltip-id={t19} {...t20}>{t21}</button>;
    $[44] = goToEtherscan;
    $[45] = t19;
    $[46] = t20;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== address.wallet || $[49] !== isTouchScreen) {
    t23 = !isTouchScreen && <Tooltip id={`etherscan-tooltip-${address.wallet}`} place="top" positionStrategy="fixed" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }} />;
    $[48] = address.wallet;
    $[49] = isTouchScreen;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== title) {
    t24 = title === "Copied!" ? <span className="tw-text-primary-400">{title}</span> : title;
    $[51] = title;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== t24) {
    t25 = <span>{t24}</span>;
    $[53] = t24;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== address.display) {
    t26 = address.display && <span className="tw-ml-3">{address.display}</span>;
    $[55] = address.display;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== t25 || $[58] !== t26) {
    t27 = <div className="tw-truncate tw-text-iron-200 md:tw-max-w-[8rem] lg:tw-max-w-[11rem]">{t25}{t26}</div>;
    $[57] = t25;
    $[58] = t26;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <svg className="tw-h-5 tw-w-5 tw-flex-shrink-0" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="#3CCB7F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  let t29;
  if ($[61] !== assignPrimary || $[62] !== assigningPrimary || $[63] !== canEdit || $[64] !== isPrimary) {
    t29 = <UserPageIdentityStatementsConsolidatedAddressesItemPrimary isPrimary={isPrimary} canEdit={canEdit} assignPrimary={assignPrimary} isAssigningPrimary={assigningPrimary} />;
    $[61] = assignPrimary;
    $[62] = assigningPrimary;
    $[63] = canEdit;
    $[64] = isPrimary;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  const t30 = `${isTouchScreen ? "tw-opacity-100" : "tw-opacity-0 group-hover:tw-opacity-100"} tw-ml-2 tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-1.5 tw-text-xs tw-font-semibold tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-200 focus:tw-outline-none`;
  const t31 = `copy-tooltip-${address.wallet}`;
  let t32;
  if ($[66] !== isTouchScreen) {
    t32 = !isTouchScreen ? {
      "data-tooltip-content": "Copy"
    } : null;
    $[66] = isTouchScreen;
    $[67] = t32;
  } else {
    t32 = $[67];
  }
  let t33;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <CopyIcon />;
    $[68] = t33;
  } else {
    t33 = $[68];
  }
  let t34;
  if ($[69] !== handleCopy || $[70] !== t30 || $[71] !== t31 || $[72] !== t32) {
    t34 = <button aria-label="Copy address" className={t30} onClick={handleCopy} data-tooltip-id={t31} {...t32}>{t33}</button>;
    $[69] = handleCopy;
    $[70] = t30;
    $[71] = t31;
    $[72] = t32;
    $[73] = t34;
  } else {
    t34 = $[73];
  }
  let t35;
  if ($[74] !== address.wallet || $[75] !== isTouchScreen) {
    t35 = !isTouchScreen && <Tooltip id={`copy-tooltip-${address.wallet}`} place="top" positionStrategy="fixed" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }} />;
    $[74] = address.wallet;
    $[75] = isTouchScreen;
    $[76] = t35;
  } else {
    t35 = $[76];
  }
  let t36;
  if ($[77] !== t29 || $[78] !== t34 || $[79] !== t35) {
    t36 = <div className="tw-inline-flex tw-items-center">{t28}{t29}{t34}{t35}</div>;
    $[77] = t29;
    $[78] = t34;
    $[79] = t35;
    $[80] = t36;
  } else {
    t36 = $[80];
  }
  let t37;
  if ($[81] !== t27 || $[82] !== t36) {
    t37 = <div className="tw-inline-flex tw-items-center tw-space-x-3">{t27}{t36}</div>;
    $[81] = t27;
    $[82] = t36;
    $[83] = t37;
  } else {
    t37 = $[83];
  }
  let t38;
  if ($[84] !== t17 || $[85] !== t18 || $[86] !== t22 || $[87] !== t23 || $[88] !== t37) {
    t38 = <div className="tw-group tw-flex tw-h-5 tw-items-center tw-space-x-3 tw-text-sm tw-font-medium tw-text-iron-200 tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-400 sm:tw-text-md">{t17}{t18}{t22}{t23}{t37}</div>;
    $[84] = t17;
    $[85] = t18;
    $[86] = t22;
    $[87] = t23;
    $[88] = t37;
    $[89] = t38;
  } else {
    t38 = $[89];
  }
  let t39;
  if ($[90] !== statusMessage) {
    t39 = statusMessage && <div className="pt-3 d-flex flex-column gap-1 tw-text-sm tw-font-medium tw-text-iron-200 sm:tw-text-md">{statusMessage}</div>;
    $[90] = statusMessage;
    $[91] = t39;
  } else {
    t39 = $[91];
  }
  let t40;
  if ($[92] !== t38 || $[93] !== t39) {
    t40 = <li>{t38}{t39}</li>;
    $[92] = t38;
    $[93] = t39;
    $[94] = t40;
  } else {
    t40 = $[94];
  }
  return t40;
}